import { render, staticRenderFns } from "./BusinessCase.vue?vue&type=template&id=96bd1a6e&scoped=true"
import script from "./BusinessCase.vue?vue&type=script&lang=js"
export * from "./BusinessCase.vue?vue&type=script&lang=js"
import style0 from "./BusinessCase.vue?vue&type=style&index=0&id=96bd1a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bd1a6e",
  null
  
)

export default component.exports